import { GetInviteFriendTierCountsResponse } from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@/core/api/type'
import { useQuery } from '@tanstack/react-query'
import { getInviteFriendTierCounts } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetInviteFriendTierCounts(
	playerId: string,
	props?: UseBaseQueryOptions<GetInviteFriendTierCountsResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetInviteFriendTierCounts, playerId],
		queryFn: () => getInviteFriendTierCounts(playerId),
		...props,
	})
}
